import { useIsMobile } from '../../../utils/hooks';
import { useAppData } from '../../../contexts/appData';
import React from 'react';
import styles from './ConnectionStatusBanner.module.css';
import { css } from '../../../utils/css';
import { ConnectionStatus } from '../../../utils/useSignalRConnection';
import { NetworkStatus } from '../../../utils/useNetworkStatus';
import { useAudioAlert } from '../alerts/AudioAlertProvider';

export const ConnectionStatusBanner: React.FC = () => {

    const { connectionStatus, networkStatus } = useAppData();
    const { status: audioStatus } = useAudioAlert();
    const isMobile = useIsMobile();

    const banner = (status: ConnectionStatus | NetworkStatus, message: string) => (
        <div className={css(styles.ConnectionStatusBanner, status)}>
            {message}
        </div>
    )

    // Offline trumps everything
    if (networkStatus === 'offline') {
        return banner('offline', 'Offline! Not receiving pages.');
    }

    if (connectionStatus === 'disconnected') {
        return banner('disconnected', 'Disconnected! Attempting to reconnect…');
    }

    if (connectionStatus === 'reconnecting') {
        return banner('reconnecting', 'Reconnecting to server…');
    }

    if (connectionStatus === 'connecting') {
        return banner('connecting', 'Connecting…');
    }

    if (connectionStatus === 'connected' && isMobile) {
        const message = audioStatus === 'unsupported'
            ? 'Connected. Audio disabled by browser.'
            : 'Connected. Receiving pages';
        return banner('connected', message);
    }

    return null; // 'connected' & desktop - render nothing
};
